<template>
  <div>
    <div class="sdk-list-container">
      <div class="load-wrap" v-show="loadPage">
        <van-loading type="spinner" size="24px" vertical>加载中...</van-loading>
      </div>
      <div v-show="loadDone">
        <p class="greement-title">{{ sdkPacket.agreeMentTitle }}</p>
        <p
          class="agreement-indent"
          v-for="(item, index) in sdkPacket.title"
          :key="index"
        >
          {{ item }}
        </p>
        <div v-for="(item, index) in sdkPacket.content" :key="index">
          <p>{{ item.subTitle }}</p>
          <div
            class="sub-content"
            v-for="(subItem, index) in item.subContent"
            :key="index"
          >
            <div class="sub-title">
              <span>{{ subItem.title }}</span
              >：
              <a
                v-if="subItem.type == 'link'"
                class="link-text"
                target="_blank"
                :href="subItem.contenList[0]"
                >{{ subItem.contenList[0] }}</a
              >
              <span v-else>{{ subItem.contenList[0] }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "sdk-list",
  data() {
    return {
      isWeixin: true,
      loadPage: true,
      loadDone: false,
      sdkPacket: {
        agreeMentTitle: "传联APP接入的第三方SDK",
        title: [
          "为保障传联App相关功能的实现与应用安全稳定的运行，我们可能会接入由第三方及关联方提供的软件开发包（SDK）实现相关目的。",
          "请注意，第三方SDK可能因为其版本升级、策略调整等原因导致数据处理类型存在一定变化，请以其公示的官方说明为准。",
          "我们会对合作方获取信息的软件工具开发包（SDK）进行严格的安全监测，以保护数据安全，与我们合作的第三方及关联方SDK如下：",
        ],
        content: [
          {
            subTitle: "1. 腾讯即时通讯 SDK",
            subContent: [
              {
                title: "使用目的",
                contenList: ["加好友、聊天、建群等"],
              },
              {
                title: "数据类型",
                contenList: ["设备标识信息"],
              },
              {
                title: "官网链接",
                type: "link",
                contenList: ["https://cloud.tencent.com/document/product/269"],
              },
            ],
          },
          {
            subTitle: "2. 高德地图 SDK",
            subContent: [
              {
                title: "使用目的",
                contenList: ["用于展现地图、地图定位"],
              },
              {
                title: "数据类型",
                contenList: ["设备标识信息、地理位置信息"],
              },
              {
                title: "官网链接",
                type: "link",
                contenList: ["https://lbs.amap.com/pages/privacy/"],
              },
            ],
          },
          {
            subTitle: "3. 支付宝（Alipay） SDK",
            subContent: [
              {
                title: "使用目的",
                contenList: ["帮助用户在应用内使用支付宝"],
              },
              {
                title: "数据类型",
                contenList: ["设备标识信息"],
              },
              {
                title: "官网链接",
                type: "link",
                contenList: ["https://docs.open.alipay.com/54"],
              },
            ],
          },
          {
            subTitle: "4. 微信开放平台 SDK",
            subContent: [
              {
                title: "使用目的",
                contenList: ["微信支付"],
              },
              {
                title: "数据类型",
                contenList: ["设备标识信息"],
              },
              {
                title: "官网链接",
                type: "link",
                contenList: ["https://open.weixin.qq.com/"],
              },
            ],
          },
          {
            subTitle: "5. 微博分享 SDK",
            subContent: [
              {
                title: "使用目的",
                contenList: ["帮助用户分享内容至第三方应用"],
              },
              {
                title: "数据类型",
                contenList: ["设备标识信息"],
              },
              {
                title: "官网链接",
                type: "link",
                contenList: [
                  "https://open.weibo.com/wiki/Android_SDK%E8%AF%B4%E6%98%8E%E6%96%87%E6%A1%A3",
                ],
              },
            ],
          },
          {
            subTitle: "6. 小米 PUSH",
            subContent: [
              {
                title: "使用目的",
                contenList: ["推送消息"],
              },
              {
                title: "数据类型",
                contenList: ["设备标识信息"],
              },
              {
                title: "官网链接",
                type: "link",
                contenList: ["https://dev.mi.com/console/appservice/push.html"],
              },
            ],
          },
          {
            subTitle: "7. VIVO PUSH",
            subContent: [
              {
                title: "使用目的",
                contenList: ["推送消息"],
              },
              {
                title: "数据类型",
                contenList: ["设备标识信息"],
              },
              {
                title: "官网链接",
                type: "link",
                contenList: ["https://dev.vivo.com.cn/documentCenter/doc/365"],
              },
            ],
          },
          {
            subTitle: "8. OPPO PUSH",
            subContent: [
              {
                title: "使用目的",
                contenList: ["推送消息"],
              },
              {
                title: "数据类型",
                contenList: ["设备标识信息"],
              },
              {
                title: "官网链接",
                type: "link",
                contenList: ["https://open.oppomobile.com/wiki/doc#id=10196"],
              },
            ],
          },
          {
            subTitle: "9. 魅族 PUSH",
            subContent: [
              {
                title: "使用目的",
                contenList: ["推送消息"],
              },
              {
                title: "数据类型",
                contenList: ["设备标识信息"],
              },
              {
                title: "官网链接",
                type: "link",
                contenList: ["https://open.flyme.cn/open-web/views/push.html"],
              },
            ],
          },
          {
            subTitle: "10. 华为 PUSH",
            subContent: [
              {
                title: "使用目的",
                contenList: ["推送消息"],
              },
              {
                title: "数据类型",
                contenList: ["设备标识信息"],
              },
              {
                title: "官网链接",
                type: "link",
                contenList: [
                  "https://developer.huawei.com/consumer/cn/hms/huawei-pushkit",
                ],
              },
            ],
          },
          {
            subTitle: "11. 极光推送",
            subContent: [
              {
                title: "使用目的",
                contenList: ["帮助提升推送消息触达和保障系统运行稳定"],
              },
              {
                title: "数据类型",
                contenList: ["设备标识信息"],
              },
              {
                title: "官网链接",
                type: "link",
                contenList: ["https://docs.jiguang.cn/jpush/guideline/intro/"],
              },
            ],
          },
        ],
      },
    };
  },
  mounted() {
    setTimeout(() => {
      this.loadPage = false;
      this.loadDone = true;
    }, 500);
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
.sdk-list-container {
  width: 750px;
  min-height: 100vh;
  margin: 0 auto;
  padding: 15px 0;
  font-size: 16px;
}

.greement-title {
  line-height: 3rem;
  text-align: center;
}

.sub-content {
  padding-left: 30px;
  /* text-align: justify; */
  line-height: 30px;
}

.agreement-indent {
  line-height: 30px;
  text-indent: 2rem;
  text-align: justify;
}

.sub-title {
  word-break: break-all;
}

.link-text {
  color: #1a70db;
}
</style>
